import React from 'react';
import ReactDOM from 'react-dom';

const LogoutModal = ({ onClose, onConfirm }) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[9999]">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl text-black font-bold mb-4">Oturumu kapatmak istediğinize emin misiniz?</h2>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-lg"
          >
            İptal
          </button>
          <button
            onClick={onConfirm}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
          >
            Çıkış
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutModal;
